import React, { useState, useContext, useEffect, useMemo, useCallback } from "react";
import { makeStyles } from "@material-ui/styles";
import { AppContext, DispatchContext } from "../../AppContext";
import TitleBar from '../../components/titleBar';
import Paper from '@material-ui/core/Paper';
import Service from "../../services/service";
import * as actions from "../../actions/actions";
import Table from '../../components/table';
import { resolveNotificationMessage, timeConverter } from '../../helpers/constants';
import IconButton from '@material-ui/core/IconButton';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import MuiAccordion from "@material-ui/core/Accordion";
import MuiAccordionSummary from "@material-ui/core/AccordionSummary";
import MuiAccordionDetails from "@material-ui/core/AccordionDetails";
import { withStyles } from "@material-ui/core/styles";
import ProjectPropertiesForm from "../../components/ProjectPropertiesForm";
import ProjectUploadForm from "../../components/ProjectUploadForm";
import InfoIcon from '@material-ui/icons/Info';
import NewProjectForm from "../../components/NewProjectForm";
import { Box, Button, FormControlLabel, FormGroup, LinearProgress, Typography, Radio, RadioGroup, Switch } from "@material-ui/core";
import CompareSource from '../../components/CompareSource';
import ShareIcon from "@material-ui/icons/Share";
import WarningIcon from '@material-ui/icons/Warning';
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import IconLabel from '../../components/IconLabel';
import { ReactComponent as FolderIcon } from '../../assets/icons/folder.svg';
import SimilarityTable from '../TextComparisons/SimilarityTable';



const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
    },
    title: {
        flex: "0 0 auto",
        height: 0,
    },
    content: {
        position: "relative",
        flex: "1 1 auto",
        overflow: "hidden",
        overflowY: "auto",    // FIXME, showing temp scroll bar during loading in table vview
        padding: theme.spacing(1),
        height: 0,  // no clue why this is required, but omitting won't display a vertical scroll bar
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        alignContent: "flex-start",
    },
    noProjectsContainer: {
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    },
    body_container: {
        display: 'flex',
        flex: '1',
        flexDirection: 'row',
        position: "relative",
    },
    projectContainerSize: {
        minWidth: (state) => {
            return state.loadingSource ? '640px' : '50%';
        },
        width: '50%',
        maxWidth: '50%',
        backgroundColor: '#ffffff',
        padding: "10px"
    },
    paper: {
        display: "flex",
        flex: "1 1 0",
        minHeight: 0,
        margin: 10,
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.1)",
        zIndex: 2,
        flexDirection: 'column',
        position: "relative"
    },
    table: {
        width: "100%",
        tableLayout: "fixed"
    },
    ellipsis: {
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        overflow: "hidden",

    },
    tableRow: {
        borderTop: '1px solid #D3D3D3',
        cursor: "pointer",
        "&:last-child": {
            borderBottom: '1px solid #D3D3D3',
        },
        "&:nth-child(even)": {
            backgroundColor: '#f3f3f3',
            "&:hover": {
                backgroundColor: '#eeeeee ',
            },
        },
        "&:nth-child(odd)": {
            backgroundColor: '#e3e3e3',
            "&:hover": {
                backgroundColor: '#eeeeee ',
            },
        }

    },
    expansion_details: {
        padding: "16px !important",
    },
    formGroupPadding: {
        padding: theme.spacing(1),
    },
    sourceIconContainer: {
        display: "flex",
        lineHeight: "revert"
    },
    table_result_header: {
        width: '65px',
        textAlign: "center"
    },
    table_action_header: {
        width: '65px',
        textAlign: "center"
    },
    table_date_header: {
        width: "130px",
        textAlign: "center",
    },
    link: {
        cursor: "pointer",
        textDecoration: "underline",
        color: "#1363a8"
    },
    selectOrCreate: {
        margin: "auto",
        textAlign: "center",
        height: "100%",
        display: "flex"
    },
    selectCreateContent: {
        margin: "auto"
    },
    infoIcon: {
        fontSize: "45px"
    },
    Link: {
        color: "#146bb2",
        cursor: "pointer",
    }
}));
const AccordionDetails = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiAccordionDetails);

const Accordion = withStyles({
    root: {
        border: "1px solid rgba(0, 0, 0, .125)",
        boxShadow: "none",
        width: "100%",
        backgroundColor: '#ffffff',
        "&:not(:last-child)": {
            borderBottom: 0,
        },
        "&:before": {
            display: "none",
        },
        "&$expanded": {
            margin: "auto",
        },
    },
    expanded: {},
})(MuiAccordion);

const AccordionSummary = withStyles({
    root: {
        backgroundColor: "#F7F7F7",
        borderBottom: "1px solid #E6E6E6",
        marginBottom: -1,
        minHeight: 40,
        height: 40,
        "&$expanded": {
            minHeight: 40,
            height: 40,
            backgroundColor: "#E6E6E6",
        },
        '&:hover': {
            cursor: "pointer",
            backgroundColor: "#EEEEEE",
            transition: 'background-color 0.2s',
        },
    },

    content: {
        "&$expanded": {
            margin: "12px 0",
        },
    },
    expanded: {},
})(MuiAccordionSummary);


export default function ProjectComponent(props) {
    const state = useContext(AppContext);
    const project = state.selectedProject;
    const s = state.strings;
    const classes = useStyles(state);
    const dispatch = useContext(DispatchContext);
    const [expanded, setExpanded] = useState("panelProperties");
    const [openSideBySideCompare, setOpenSideBySideCompare] = useState(false);
    const [collusionsLoading, setCollusionsLoading] = useState(false);
    const [loading, setLoading] = useState(false);

    // reload projects if filter settings have changed
    useEffect(() => {
        loadProjects();
    }, [state.projectsFilterChangeNo]);

    function loadProjects() {
        dispatch(actions.get_projects_filter([]));
        if (state.projects && state.projects.length > 1) {
            let filteredData = state.projects;
            if (state.projects && state.projects.length > 1 && state.projectFilter.search) {
                filteredData = state.projects.filter((item) => (item.Name.toLowerCase()).indexOf(state.projectFilter.search.toLowerCase()) > -1)
            }
            if (filteredData && filteredData.length > 1 && state.projectPagination && state.projectPagination.sortby) {
                if (state.projectPagination.sortby === 'PlagChecks' || state.projectPagination.sortby === 'LibraryTexts') {
                    filteredData.slice().sort((a, b) => {
                        return (+a[state.projectPagination.sortby] - +b[state.projectPagination.sortby]);
                    });
                } else {
                    filteredData.slice().sort((a, b) => {
                        return ('' + a[state.projectPagination.sortby]).localeCompare(b[state.projectPagination.sortby]);
                    });
                }
            }
            dispatch(actions.get_projects_filter(filteredData || []));
            dispatch(actions.change_project_pagination(state.projectPagination));
            if (state.selectedProject) {
                let rowDetails = filteredData.filter(i => i.Id === state.selectedProject.Id)[0];
                onActiveRowHandle(rowDetails);
            }
        }
    }

    const columns = useMemo(() => [
        {
            Header: s.name,
            accessor: "Name",
            cellClassName: classes.table_title_header,
            headerClassName: classes.table_title_header,
        },
        {
            Header: s.common.shared,
            accessor: "AllowShare",
            Cell: ({ cell: { value, row } }) => <div>
                {value == 1 ?
                    <IconButton data-for="globalTT" data-place="top" data-tip={s.libraryOverview.sharedTip} disabled={!row.original.IsOwner} size="small" onClick={(e) => { setExpanded("panelPermissions") }}> <ShareIcon /></IconButton>
                    : "-"}
            </div>,
            headerClassName: classes.table_action_header,
            cellClassName: classes.table_action_header,
        },
        {
            Header: s.date,
            accessor: "Date",
            Cell: ({ cell: { value } }) => <>{timeConverter(value, null, s.common.dateFormat)}</>,
            headerClassName: classes.table_date_header,
            cellClassName: classes.table_date_header,
        },
        {
            Header: s.common.texts,
            accessor: "LibraryTexts",
            headerClassName: classes.table_result_header,
            cellClassName: classes.table_result_header,
            Cell: ({ cell: { value, row } }) =>
                <div>
                    {value != 0 ?
                        <div className={classes.link} onClick={(e) => clickText(e, row.original)}>
                            {value}
                        </div> :
                        <div>
                            -
                        </div>
                    }
                </div>,
        },
        {
            Header: s.common.plagChecks,
            accessor: "PlagChecks",
            headerClassName: classes.table_date_header,
            cellClassName: classes.table_date_header,
            Cell: ({ cell: { value, row } }) =>
                <div>
                    {value != 0 ?
                        <div className={classes.link} onClick={(e) => clickCheck(e, row.original)}>
                            <span>{value}</span>
                        </div> :
                        <div>
                            <span>-</span>
                        </div>
                    }
                </div>,
        },
        {
            Header: s.actions,
            accessor: "Actions",
            headerClassName: classes.table_action_header,
            cellClassName: classes.table_action_header,
            disableSortBy: true,
            Cell: ({ cell: { value, row } }) => <div>
                <IconButton disabled={row.original.IsOwner == 0} size="small" onClick={(e) => onDeleteProject(e, row.original)}> <DeleteForeverIcon /></IconButton>
            </div>,
        },
    ], [state.lang]
    );

    const onDeleteProject = (e, row) => {
        e && e.stopPropagation();
        dispatch(actions.openConfirmationDialog({
            title: s.projectsOverview.deleteProjectTitle,
            text: s.projectsOverview.deleteProjectText,
            hint: s.projectsOverview.deleteProjectHint,
            waitingMessage: s.projectsOverview.deleteProjectWaiting,
            onConfirm: () => deleteProject(row.Id)
        }));
    }

    const deleteProject = (projectid) => {
        Service.deleteProject(projectid).then(res => {
            dispatch(actions.closeConfirmationDialog());
            if (res && res.success) {
                dispatch(actions.notifyProjectsChanged());
                if (res.message === 'notificationMessage.projectDeleted') {
                    dispatch(actions.openToast({ type: "success", message: s.notificationMessage.projectDeleted, status: true }));
                }
            } else {
                dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
            }
        });
    }

    const rowSelectedHandle = (rows) => {

    }

    const clickText = (e, row) => {
        e && e.stopPropagation();
        const filter = {
            projectId: row.Id,
            search: "",
            date: "",
            state: "",
        };
        dispatch(actions.apply_library_filter(filter));
        dispatch(actions.navigate_to('/library/overview'));
    }

    const clickCheck = (e, row) => {
        e && e.stopPropagation();
        const filter = {
            projectId: row.Id,
            search: "",
            date: "",
            state: "",
        };
        dispatch(actions.apply_report_filter(filter));
        dispatch(actions.navigate_to('/plagiarism/reports'));
    }

    const onActiveRowHandle = async (rowDetails) => {
        if (rowDetails) {
            dispatch(actions.changeProjectSelection(rowDetails));
            loadCollusions(rowDetails.Id);
        } else {
            dispatch(actions.changeProjectSelection({}));
        }
    }

    const handleSort = (sortBy) => {
        const sortByDetails = (sortBy && sortBy[0]) || {
            id: 'Name',
            desc: true
        };
        const projectFilter = {
            sortby: sortByDetails.id,
            sortdir: sortByDetails.desc === true ? 'desc' : 'asc'
        };
        dispatch(actions.change_project_pagination(projectFilter));
    }

    const createProjectPopup = () => {
        dispatch(actions.create_project_popup(true));
    }

    const changeAccordian = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
        if (newExpanded && (panel == "panel3")) {
            loadCollusions(state.selectedProject.Id);
        }
    };

    const loadCollusions = (projectId) => {
        setCollusionsLoading(true);
        Service.getCollusionSources(projectId).then(res => {
            if (res && res.success && res.data) {
                dispatch(actions.setCollusion({ sources: res.data.sources, left: res.data.left }));
            } else {
                dispatch(actions.setCollusion({ sources: [], left: 0 }));
            }
            setCollusionsLoading(false);
        });
    }

    const collusionCheckChanged = (checked) => {
        if (checked) {
            Service.createCollusionReport(state.selectedProject.Id).then(res => {
                if (res && res.success) {
                    loadCollusions(state.selectedProject.Id);
                    dispatch(actions.openToast({ message: s.projectsOverview.collusionStarted }));
                    dispatch(actions.notifyProjectsChanged());
                } else {
                    dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
                }
            });
        } else {
            dispatch(actions.openConfirmationDialog({
                title: s.projectsOverview.deactivateCollusionTitle,
                text: s.projectsOverview.deactivateCollusionText,
                hint: s.projectsOverview.deactivateCollusionHint,
                waitingMessage: s.projectsOverview.deactivateCollusionWaiting,
                onConfirm: () => deleteCollusionCheck(state.selectedProject.Id),
            }));

        }
    }

    const deleteCollusionCheck = (projectId) => {
        Service.deleteCollusionReport(projectId).then(res => {
            if (res.success) {
                dispatch(actions.changeProjectSelection(projectId));
                dispatch(actions.notifyProjectsChanged());
            }
            dispatch(actions.closeConfirmationDialog());
        });
    }

    const handleShowCompareDialog = (src) => {
        dispatch(actions.setActiveSource(src));
        Service.getSourceMarkup(src.Id).then(res => {
            if (res.success && res.data) {
                dispatch(actions.setSourceMarkup(res.data));
            }
        });
        setOpenSideBySideCompare(true);
    }

    const handleCloseShowCompareDialog = useCallback(() => {
        setOpenSideBySideCompare(false);
        dispatch(actions.setSourceMarkup({}));
    });

    const collusionComparison = useMemo(() => ({
        id: state.selectedProject?.Id,
        sources: (state.collusion.sources || []).map(src => ({
            id: src.Id,
            rawId: src.Id,
            title: `${src.Text1.Name} \u2194 ${src.Text2.Name}`,
            text1: { id: src.Text1?.Id, name: src.Text1.Name, words: src.Text1?.Words ?? null },
            text2: { id: src.Text2?.Id, name: src.Text2.Name, words: src.Text2?.Words ?? null },
            percent: src.Id === null ? null : src.Percent,
            percent2: src.Id === null ? null : (src.Percent2 ?? src.Percent),
            mw: src.Id === null ? 0 : (src.MW ?? 0),
        })),
    }), [state.collusion.sources, state.selectedProject?.Id]);

    const onProjectPropertyChanged = (fieldId, newValue) => {
        let sendData = { ...project, projectid: project.Id };
        sendData[fieldId] = (newValue == "1") ? 1 : 0
        Service.UpdateProject(sendData).then(res => {
            if (res.success) {
                dispatch(actions.notifyProjectsChanged());
                if (res.message === 'notificationMessage.projectUpdated') {
                    dispatch(actions.openToast({ type: "success", message: s.notificationMessage.projectUpdated, status: true }));
                }
            } else {
                dispatch(actions.openToast({ type: "false", message: res.errors[0], status: true }));
            }
        });
    }

    const saveProject = (props) => {
        const currentData = {
            ...project,
            projectId: project.Id
        }
        const submitData = {
            ...project,
            ...props,
            projectId: project.Id
        }
        if (JSON.stringify(currentData) === JSON.stringify(submitData))
            return;
        Service.UpdateProject(submitData).then(res => {
            if (res.success) {
                dispatch(actions.notifyProjectsChanged());
                if (res.message === 'notificationMessage.projectUpdated') {
                    dispatch(actions.openToast({ type: "success", message: s.notificationMessage.projectUpdated, status: true }));
                }
            } else {
                dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage) }));
            }
        });
    }


    return (
        <div className={classes.root}>
            {openSideBySideCompare && <CompareSource noRating open={openSideBySideCompare} onHandleClose={handleCloseShowCompareDialog} />}

            {state.openCreateProjectPopup && <NewProjectForm />}
            <TitleBar className={classes.title} title={s.projects} type="ProjectOverview" />
            <div className={classes.body_container}>
                <Paper elevation={3} className={classes.paper}>
                    <div className={classes.content}>
                        {state.projects.length === 0 ?
                            <div className={classes.noProjectsContainer}>
                                <FolderIcon fill="#0D4A81" height={100} width={100} style={{ marginBottom: 16 }} />
                                <div style={{ maxWidth: 600 }}>
                                    <Typography paragraph align="center">{s.projectsOverview.noProjectsDefined}</Typography>
                                    <Typography variant="body2" color="secondary" align="center">{s.projectsOverview.noProjectsHint}</Typography>
                                </div>
                                <Box mt={3} />
                                <Button variant="contained" color="primary" onClick={() => createProjectPopup()}>{s.createNewProject}</Button>
                            </div>
                        :
                        <Table
                            data={state.filteredProjects}
                            onSelectedRowsChange={rowSelectedHandle}
                            selectedIds={state.selectedReportIds}
                            columns={columns}
                            onActiveRowChanged={onActiveRowHandle}
                            activeRowId={state.selectedProject.Id}
                            onSort={handleSort}
                            onSortBy={state.projectPagination}
                            loading={false}
                        />}
                    </div>
                </Paper>
                {state.projects.length > 0 && <div className={classes.projectContainerSize}>
                    {state.selectedProject && state.selectedProject.Id ?
                        <div className={classes.detailsPanel}>
                            <div className={classes.propertiesPanel}>
                                <Accordion
                                    expanded={expanded === "panelProperties"}
                                    onChange={changeAccordian("panelProperties")}>
                                    <AccordionSummary
                                        className={classes.pannelSummary}
                                        aria-controls="panel1d-content"
                                        id="panel1d-header">
                                        {s.properties}
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.expansion_details}>
                                        <ProjectPropertiesForm project={project} saveProject={saveProject}></ProjectPropertiesForm>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expanded === "panelRating"}
                                    onChange={changeAccordian("panelRating")}>
                                    <AccordionSummary
                                        className={classes.pannelSummary}
                                        aria-controls="panel1d-content"
                                        id="panel1d-header">
                                        {s.libraryOverview.ratingOfMatches}
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.expansion_details}>
                                        <div style={{ display: "column", flexDirection: "row", alignItems: "left", width: "100%" }}>
                                            <Typography>{s.libraryOverview.rateMatchesAs}</Typography>
                                            <Box mt={1} />
                                            <RadioGroup name="textRating" value={project.AcceptTexts} onChange={(e) => onProjectPropertyChanged("AcceptTexts", e.target.value)}>
                                                <FormControlLabel value={0} control={<Radio disabled={loading || !project.IsOwner} checked={project.AcceptTexts == 0} />}
                                                    label={<IconLabel label={s.suspiciousSource + " " + "(default)"} icon={<WarningIcon style={{ color: "orange" }} />} />}
                                                />
                                                <FormControlLabel value={1} control={<Radio disabled={loading || !project.IsOwner} checked={project.AcceptTexts == 1} />}
                                                    label={<IconLabel label={s.acceptedSource} icon={<CheckCircleIcon style={{ color: "#017d01" }} />} />}
                                                />
                                            </RadioGroup>
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expanded === "panel2"}
                                    onChange={changeAccordian("panel2")}>
                                    <AccordionSummary
                                        className={classes.pannelSummary}
                                        aria-controls="panel1d-content"
                                        id="panel1d-header">
                                        {s.uploadForm}
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.expansion_details}>
                                        <ProjectUploadForm project={project} saveProject={saveProject}></ProjectUploadForm>
                                    </AccordionDetails>
                                </Accordion>
                                <Accordion
                                    expanded={expanded === "panel3"}
                                    onChange={changeAccordian("panel3")}>
                                    <AccordionSummary
                                        className={classes.pannelSummary}
                                        aria-controls="panel1d-content"
                                        id="panel1d-header">
                                        {s.collusionCheck}
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.expansion_details} style={{ display: "flex", flexDirection: "column" }}>
                                        <FormGroup className={classes.formGroupPadding} >
                                            <FormControlLabel
                                                control={<Switch checked={!!state.selectedProject.CollusionReportId} disabled={!project.IsOwner} onChange={(e) => collusionCheckChanged(e.target.checked)} />}
                                                label={<span className={classes.sourceIconContainer}>{s.activateCollusion}</span>} />
                                        </FormGroup>
                                        {!!state.selectedProject.CollusionReportId &&
                                            (collusionsLoading ? <LinearProgress style={{ width: "100%" }} /> :
                                                (state.collusion.sources.length ?
                                                    <><div style={{ display: "flex", alignItems: "baseline", gap: 8, flexWrap: "wrap" }}>
                                                        <Typography>{s.projectsOverview.detectedSimiliarities.format(state.collusion.sources.length)}</Typography>
                                                        <span
                                                            style={{ color: "#1565c0", cursor: "pointer", fontSize: 13, textDecoration: "underline" }}
                                                            onClick={() => dispatch(actions.navigate_to(`/tools/comparisons/${state.selectedProject.CollusionReportId}`))}
                                                        >
                                                            {s.projectsOverview.openInTextComparisonView || "Open in text comparison view"}
                                                        </span>
                                                    </div>
                                                        {state.collusion.left > 0 && <Typography variant="caption" color="secondary">{s.projectsOverview.pending.format(state.collusion.left)}</Typography>}
                                                        <div style={{ marginTop: 8, height: 300, display: "flex", flexDirection: "column" }}>
                                                            <SimilarityTable
                                                                comparison={collusionComparison}
                                                                threshold={[0, 100]}
                                                                onSourceClick={(src) => {
                                                                    const original = state.collusion.sources.find(s => s.Id === src.rawId);
                                                                    if (original) handleShowCompareDialog(original);
                                                                }}
                                                            />
                                                        </div>
                                                    </>
                                                    :
                                                    <>
                                                        <Typography>{s.projectsOverview.noSimilarities}</Typography>
                                                        {state.collusion.left > 0 && <Typography variant="caption" color="secondary">{s.projectsOverview.pending.format(state.collusion.left)}</Typography>}
                                                    </>
                                                )
                                            )
                                        }
                                    </AccordionDetails>
                                </Accordion>
                                {((state.user.userId == state.user.license.adminUserId) || (project && !project.IsOwner)) &&
                                    <Accordion
                                        expanded={expanded === "panelPermissions"}
                                        onChange={changeAccordian("panelPermissions")}>
                                        <AccordionSummary className={classes.pannelSummary}>
                                            {s.libraryOverview.licensePermissions}
                                        </AccordionSummary>
                                        <AccordionDetails className={classes.expansion_details}>
                                            <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch", padding: 10 }}>
                                                <Typography>{s.libraryOverview.permitForAllLicenseUsers}</Typography>
                                                <Box mt={1} />
                                                <FormControlLabel
                                                    control={<Switch disabled={!project.IsOwner} checked={!!project.AllowShare} onChange={(e) => onProjectPropertyChanged("AllowShare", e.target.checked)} />}
                                                    label={s.libraryOverview.allowProjectSharing}
                                                />
                                                <FormControlLabel
                                                    control={<Switch disabled={!project.IsOwner || !project.AllowShare} checked={!!project.AllowBrowse} onChange={(e) => onProjectPropertyChanged("AllowBrowse", e.target.checked)} />}
                                                    label={s.libraryOverview.allowBrowse}
                                                />
                                                <FormControlLabel
                                                    control={<Switch disabled={!project.IsOwner || !project.AllowShare} checked={!!project.AllowAdd} onChange={(e) => onProjectPropertyChanged("AllowAdd", e.target.checked)} />}
                                                    label={s.libraryOverview.allowAddTexts}
                                                />
                                            </div>
                                        </AccordionDetails>
                                    </Accordion>
                                }
                                <Accordion
                                    expanded={expanded === "panelDetails"}
                                    onChange={changeAccordian("panelDetails")}>
                                    <AccordionSummary className={classes.pannelSummary}>
                                        {s.common.details}
                                    </AccordionSummary>
                                    <AccordionDetails className={classes.expansion_details}>
                                        <div style={{ display: "flex", flexDirection: "column", alignItems: "stretch", padding: 10 }}>
                                            <Typography>{s.projectsOverview.projectId} {state.selectedProject.Id}</Typography>
                                            {project && project.OwnerMail &&
                                                <Typography> {s.common.owner + ": " + state.selectedProject.OwnerMail}</Typography>
                                            }
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            </div>
                        </div> :
                        <div className={classes.selectOrCreate}>
                            <div className={classes.selectCreateContent}>
                                <InfoIcon className={classes.infoIcon} />
                                <p>
                                    {s.selectProject} <a className={classes.Link} onClick={() => { createProjectPopup(); }}>{s.createNewProject}</a>.
                                </p>
                            </div>
                        </div>}
                </div>}
            </div>
        </div >
    )
}